export default "__VITE_ASSET__BXHHGgP2__"